import React from "react";
import { Box, Grid2, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";

import dashboard from "../../../../Images/e-Form/dashboard.png";
import formList from "../../../../Images/e-Form/form.png"; 
import suppliers from "../../../../Images/e-Form/suppliers.png"; 
import wave from "../../../../Images/aboutUsBg.jpg";
// import wave from "../../../../Images/aboutUsBg.jpg";
import { commonCss } from "../../../../CssStyle/commonCss";
import WaveBackground from "../../../../Component/WaveBackground";
import { ArrowForward } from "@mui/icons-material";

const E_Form = () => {
  return (
    <Grid2 container spacing={"2rem"} >
     <WaveBackground menu={"Our Products"} title={"Security e-Form"} description={"A Streamlined Solution For Secure Submission And Management Of Security Forms."}/>
    

     <Grid2 container justifyContent={"center"}>
           <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"0 3rem 3rem 3rem"},maxWidth:{xs:"auto",xl:"2000px"}}} alignItems={"center"} mt="-10%" >
             <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-start"}}>
            <img src={dashboard} style={{width:'85%',height:"100%"}}/>
        </Grid2>
        <Grid2 size={{xs:12,md:6}} sx={{pr:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},textAlign:{xs:"center",md:"left"},fontWeight:700,fontFamily:"inherit"}}>Secuity e_Form Web App</Typography>
            <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Security E-Form</span> is a digital solution designed to streamline security-related documentation, ensuring accurate data collection, improved record management, and enhanced security protocols. This platform enables users to submit, manage, and review security forms efficiently through a web interface.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography>
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1rem",
              fontWeight:600
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:1,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Digital Form Submission</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Data Validation</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Secure Access Control</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Audit Logs</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Employee Engagement</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>File Upload Support</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Analytics & Reporting</ListItemText>
                </ListItem>
                
            </List>
        </Grid2>
     </Grid2>
     </Grid2>
     <Grid2 container justifyContent={"center"} sx={{background:commonCss.backgroundGray}} >
          <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"3rem"},maxWidth:{xs:"auto",md:"2000px"}}} alignItems={"center"}>
     <Grid2 size={{xs:12,md:6}} sx={{pl:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},fontWeight:700,fontFamily:"inherit"}}>A user-friendly platform that enhances security workflows with digital form submission, real-time tracking, and secure data storage.
</Typography>
            <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>Look no further than our Secuity e-Form
solution.
</Typography>
            
            {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1rem",
              fontWeight:600
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:4,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Ability to digital solution for reporting & tracking security findings.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Digitally route reports for multi-level approvals
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Streamlined incident management for quick reporting and resolution.
                  </ListItemText>
                </ListItem>
              
            </List>
        </Grid2>
        <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-end"}}>
            <img src={formList} style={{width:'85%',height:"100%"}}/>
        </Grid2>
      
     </Grid2>
     </Grid2>
       <Grid2 container justifyContent={"center"}>
          <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"3rem"},maxWidth:{xs:'auto',xl:"2000px"}}} alignItems={"center"}  >
        <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-start"}}>
            <img src={suppliers} style={{width:'85%',height:"100%"}}/>
        </Grid2>
        <Grid2 size={{xs:12,md:6}} sx={{pr:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},fontWeight:700,fontFamily:"inherit"}}>Benefits</Typography>
            {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1.1rem",
              fontWeight:400
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:1,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Allows image attachments for clear evidence and detailed reporting.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Enables users to submit and review forms from any device, anytime.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>racks submissions, approvals, and updates for improved transparency.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Improves team communication with task tracking and alerts.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Digital forms with validation reduce errors and ensure complete information.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Ensures sensitive information is protected with role-based access control.</ListItemText>
                </ListItem>
            </List>
        </Grid2>
     </Grid2>
     </Grid2>
    </Grid2>
  );
};

export default E_Form;
